import { keyEmptyCheck } from 'aurora-utils/utils';

export const DED_LICENSE_SOURCE = 1020;
export const ADGM_LICENSE_SOURCE = 1036;

export const DED_TRADE_LICENSE_NUMBER_OPTIONS = [
  {
    label: 'CN',
    value: 'CN',
  },
  {
    label: 'IN',
    value: 'IN',
  },
];

export const STEPS_APIS_STATUSES_DEFAULT = {
  fetchLookups: false,
  fetchDocuments: false,
  fetchUser: false,
};

export const COMPONENTS_NAMES = {
  COMPANY_DETAILS: 'CompanyDetails',
  DOCUMENTS: 'Documents',
  APPLICANT_DETAILS: 'ApplicantDetails',
  RESPONSE_DOCUMENT: 'ResponseDocument',
  ACTIVITIES: 'ACTIVITIES',
};

export const STEPS = ['company_details', 'upload_document', 'Review'];

export const FLOWS = {
  INITIATOR: 'initiator',
  POST_FLOW: 'postSubmissionFlow',
};

export const applicantTypeValues = {
  owner: 'OWNER',
  partner: 'PARTNER',
  employee: 'EMPLOYEE',
  signatory: 'SIGNATORY',
  manager: 'MANAGER',
};

export const authorizedByValues = {
  moa: 'MOA',
  license: 'TRADE_LICENSE',
  bod: 'BOD_DECISION',
  cat: 'COMPANY_ACKNOWLEDGEMENT_LETTER',
  partnership: 'PARTNERSHIP_AGREEMENT',
  poa: 'POA',
};

export const documentTypes = {
  cat: 'COMPANY_ACKNOWLEDGEMENT_LETTER',
  poa: 'POA_DOCUMENT',
  passport: 'PASSPORT',
  eid: 'APPLICANT_EID',
  license: 'COMMERCIAL_LICENSE',
  bod: 'BOARD_OF_DIRECTORS_DECISION',
  moa: 'MOMENTUM_OF_ASSOCIATION',
  partnership: 'PARTNERSHIP_AGREEMENT',
  other: 'ADD_COMPANY_OTHERS',
};

export const DROPDOWNS_OPTIONS = {
  companyOriginsList: [
    {
      label: keyEmptyCheck('inside_uae'),
      value: 'Inside_UAE',
    },
    {
      label: keyEmptyCheck('outside_uae'),
      value: 'Outside_UAE',
    },
  ],
  companyTypesList: [
    {
      label: keyEmptyCheck('headquarters'),
      value: 'HEADQUARTERS',
    },
    {
      label: keyEmptyCheck('branch'),
      value: 'BRANCH',
    },
  ],
  applicantTypesList: [
    {
      label: keyEmptyCheck('Owner'),
      value: applicantTypeValues?.owner,
    },
    {
      label: keyEmptyCheck('PARTNER'),
      value: applicantTypeValues?.partner,
    },
    {
      label: keyEmptyCheck('EMPLOYEE'),
      value: applicantTypeValues?.employee,
    },
    {
      label: keyEmptyCheck('Manager'),
      value: applicantTypeValues?.manager,
    },
  ],
  EmployeeAuthorizedByList: [
    {
      label: keyEmptyCheck('poa'),
      value: authorizedByValues?.poa,
    },
  ],
  PartnerAuthorizedByList: [
    {
      label: keyEmptyCheck('partnership_agreement'),
      value: authorizedByValues?.partnership,
    },
  ],
};

export const COMPANY_DETAILS_KEYS = {
  companyNameEn: 'companyNameEn',
  companyNameAr: 'companyNameAr',
  tradeLicenseNumber: 'tradeLicenseNumber',
  companyOrigin: 'companyOrigin',
  companyType: 'companyType',
  legalForm: 'legalFormId',
  adcciNumber: 'adcciNumber',
  licenseIssueDate: 'licenseIssueDate',
  licenseExpiryDate: 'licenseExpiryDate',
  establishmentDate: 'establishmentDate',
  licenseSource: 'licenseSourceId',
  tradeName: 'tradeName',
  emirate: 'emirateId',
  city: 'cityId',
  companyEmail: 'companyEmail',
  companyLandline: 'companyLandline',
  mobileNumber: 'mobileNumber',
  companyFax: 'companyFax',
  companyAddressEn: 'companyAddressEn',
  companyAddressAr: 'companyAddressAr',
  applicantType: 'applicantType',
  authorizedBy: 'authorizedBy',
};

export const REVIEW_COMPONENTS = [
  COMPONENTS_NAMES.APPLICANT_DETAILS,
  COMPONENTS_NAMES.COMPANY_DETAILS,
  COMPONENTS_NAMES.ACTIVITIES,
  COMPONENTS_NAMES.DOCUMENTS,
  COMPONENTS_NAMES.RESPONSE_DOCUMENT,
];
